import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import alert from "./src/alert.vue";
import AlertRule from "./src/alert-rule.vue";
export const xAlert = withInstall(alert, { AlertRule });
export const xAlertRule = withNoopInstall(AlertRule);
export default xAlert;
export * from "./src/alert";
export * from "./src/alert-rule";
